const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchNoInvoicedJyorders ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/invoice/search-no-invoiced-jyorders', { params })
  },
  searchNoInvoicedVaorders ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/invoice/search-no-invoiced-vaorders', { params })
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/invoice/search', { params })
  },
  createByJyorder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jye/v1frontend/invoice/create-by-jyorder', params)
  },
  createByVaorder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jye/v1frontend/invoice/create-by-vaorder', params)
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/invoice/view', { params })
  },
  issue ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jye/v1frontend/invoice/issue', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
